<template>
    <div class="home d-flex">
        <v-container fluid class="d-flex flex-grow-1">
            <v-row dense class="d-flex flex-grow-1">
                <v-col lg="12" md="12" xs="12" cols="12">
                    <v-card
                        outlined
                        class="d-flex flex-column"
                        style="height: 100%"
                    >
                        <v-card-title
                            style="border-bottom: 1px solid #404040"
                            class="pt-2 pb-2"
                        >
                            <div class="text-left v-card-custom-title-left">
                                {{ $t("lp.symbolMapping.title") }}
                            </div>
                            <div class="text-right v-card-custom-title-right">
                                <v-btn
                                    v-if="selectedLpId > 0"
                                    small
                                    color="default"
                                    :loading="loading"
                                    @click="
                                        handleAddSymbol(
                                            selectedLpId,
                                            selectedLp
                                        )
                                    "
                                    >{{
                                        $t("lp.symbolMap.addSymbolMap")
                                    }}</v-btn
                                >
                                <v-menu offset-y dense max-height="800">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            small
                                            color="primary"
                                            dark
                                            v-bind="attrs"
                                            v-on="on"
                                            class="mr-1 ml-1"
                                        >
                                            {{ selectedLp }}
                                        </v-btn>
                                    </template>
                                    <v-list dense>
                                        <v-list-item
                                            v-for="(item, index) in [
                                                {
                                                    id: -1,
                                                    lp_name: $t(
                                                        'lp.symbolMapping.all'
                                                    ),
                                                },
                                                ...lpList,
                                            ]"
                                            :key="item.id"
                                            v-on:click="changeLp(item)"
                                        >
                                            <v-list-item-title>{{
                                                item.lp_name.toUpperCase()
                                            }}</v-list-item-title>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>
                                <v-btn
                                    small
                                    color="default"
                                    :loading="loading"
                                    @click="refreshMapping"
                                    ><v-icon>mdi-refresh</v-icon></v-btn
                                >
                            </div>
                        </v-card-title>

                        <v-data-table
                            class="flex-grow-1"
                            dense
                            :headers="symbolMapHeader"
                            :items="filteredData"
                            :loading="loading"
                            :loading-text="$t('lp.eodPosition.loadingText')"
                            :items-per-page="-1"
                            :height="tableHeight"
                            :hide-default-footer="true"
                            fixed-header
                            item-key="computedId"
                            :header-props="{ sortIcon: null }"
                        >
                            <template v-slot:header.api_code="{ header }">
                                {{ header.text }}
                                <v-menu
                                    offset-y
                                    :close-on-content-click="false"
                                    top
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon
                                            small
                                            v-bind="attrs"
                                            v-on="on"
                                            @click.prevent="
                                                onSearch('apiCodeSearch')
                                            "
                                        >
                                            mdi-magnify
                                        </v-icon>
                                    </template>
                                    <div
                                        style="
                                            background-color: #1e1e1e;
                                            width: 280px;
                                        "
                                    >
                                        <v-text-field
                                            v-model="apiSearch"
                                            class="px-4"
                                            type="text"
                                            ref="apiCodeSearch"
                                            :label="
                                                $t(
                                                    'lp.symbolMapping.enterSearchTerm'
                                                )
                                            "
                                            style="width: 100%"
                                            single-line
                                            hide-details
                                        ></v-text-field>
                                        <v-btn
                                            @click="apiSearch = ''"
                                            small
                                            text
                                            color="primary"
                                            class="ml-2 mb-2"
                                            style="padding: 6px"
                                        >
                                            {{ $t("lp.symbolMapping.clean") }}
                                        </v-btn>
                                    </div>
                                </v-menu>
                            </template>
                            <template v-slot:header.pk="{ header }">
                                {{ header.text }}
                                <v-menu
                                    offset-y
                                    :close-on-content-click="false"
                                    top
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon
                                            small
                                            v-bind="attrs"
                                            v-on="on"
                                            @click.prevent="
                                                onSearch('pkSearch')
                                            "
                                        >
                                            mdi-magnify
                                        </v-icon>
                                    </template>
                                    <div
                                        style="
                                            background-color: #1e1e1e;
                                            width: 280px;
                                        "
                                    >
                                        <v-text-field
                                            v-model="pkSearch"
                                            class="px-4"
                                            type="text"
                                            ref="pkSearch"
                                            :label="
                                                $t(
                                                    'lp.symbolMapping.enterSearchTerm'
                                                )
                                            "
                                            style="width: 100%"
                                            single-line
                                            hide-details
                                        ></v-text-field>
                                        <v-btn
                                            @click="pkSearch = ''"
                                            small
                                            text
                                            color="primary"
                                            class="ml-2 mb-2"
                                            style="padding: 6px"
                                        >
                                            {{ $t("lp.symbolMapping.clean") }}
                                        </v-btn>
                                    </div>
                                </v-menu>
                            </template>
                            <template v-slot:item.action="{ item }">
                                <v-icon dense v-on:click="toggleDialog(item)"
                                    >mdi-pen</v-icon
                                >
                                <v-icon
                                    class="ml-1"
                                    dense
                                    @click="
                                        dialogRemove.visible = true;
                                        removeData = [item];
                                    "
                                    >mdi-delete</v-icon
                                >
                            </template>
                        </v-data-table>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
        <v-dialog
            v-model="dialogMapping.visible"
            :fullscreen="dialogMapping.fullscreen"
            width="1200"
            :hide-overlay="true"
            :persistent="true"
        >
            <v-card class="pt-0">
                <v-app-bar
                    flat
                    color="rgba(0, 0, 0, 0)"
                    style="background: rgb(26, 57, 88)"
                >
                    <v-toolbar-title class="text-h6 white--text pl-0">{{
                        dialogMapping.title
                    }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="white"
                        icon
                        @click="
                            dialogMapping.fullscreen = !dialogMapping.fullscreen
                        "
                        ><v-icon>mdi-arrow-expand</v-icon></v-btn
                    >
                    <v-btn
                        color="white"
                        icon
                        @click="dialogMapping.visible = false"
                        ><v-icon>mdi-close</v-icon></v-btn
                    >
                </v-app-bar>

                <v-form>
                    <v-container>
                        <v-row
                            v-for="data in Object.keys(
                                dialogMapping.symbolMapInfo
                            )"
                            :key="data"
                        >
                            <v-col cols="3">
                                <label
                                    style="
                                        display: flex;
                                        align-items: center;
                                        height: 100%;
                                    "
                                >
                                    {{ updateTitle[data] }}
                                    <!-- {{ data.replaceAll("_", " ") }} -->
                                </label>
                            </v-col>
                            <v-col cols="9">
                                <v-text-field
                                    v-model="dialogMapping.symbolMapInfo[data]"
                                    :readonly="
                                        data == 'id' ||
                                        data == 'Symbol' ||
                                        data == 'Server Name'
                                    "
                                    required
                                    :placeholder="
                                        $t(
                                            'lp.symbolMapping.enterNewValueFor'
                                        ) + data.replaceAll('_', ' ')
                                    "
                                ></v-text-field
                            ></v-col>
                        </v-row>
                    </v-container>
                </v-form>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="green darken-1"
                        text
                        @click="dialogMapping.visible = false"
                        :disabled="loading"
                        >{{ $t("common.form.cancel") }}</v-btn
                    >
                    <v-btn
                        color="green darken-1"
                        text
                        @click="updateMapping()"
                        :loading="loading"
                        ><span>{{ $t("common.form.update") }}</span></v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
        <batch-add-symbol-map-dialog
            ref="batchDialog"
            v-bind="$attrs"
            :selected-lp-id="selectedLpId"
        />
        <v-dialog
            v-model="dialogRemove.visible"
            :fullscreen="dialogRemove.fullscreen"
            width="1300"
            :hide-overlay="true"
            :persistent="true"
        >
            <v-card class="pt-0">
                <v-app-bar
                    flat
                    color="rgba(0, 0, 0, 0)"
                    style="background: rgb(26, 57, 88)"
                >
                    <v-toolbar-title class="text-h6 white--text pl-0">{{
                        dialogRemove.title
                    }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="white"
                        icon
                        @click="
                            dialogRemove.fullscreen = !dialogRemove.fullscreen
                        "
                        ><v-icon>mdi-arrow-expand</v-icon></v-btn
                    >
                    <v-btn
                        color="white"
                        icon
                        @click="dialogRemove.visible = false"
                        ><v-icon>mdi-close</v-icon></v-btn
                    >
                </v-app-bar>

                <v-card-actions>
                    <v-row>
                        <v-col
                            cols="12"
                            sm="12"
                            md="12"
                            lg="12"
                            xl="12"
                        ></v-col>
                        <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                            <v-data-table
                                dense
                                :headers="
                                    symbolMapHeader.filter(
                                        (item) => item.value !== 'action'
                                    )
                                "
                                :items="removeData"
                                item-key="id"
                                class="elevation-0"
                                :loading="loading"
                                :items-per-page="-1"
                                id="home-table"
                                :hide-default-footer="true"
                                fixed-header
                                :header-props="{ sortIcon: null }"
                            >
                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-card-actions>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="green darken-1"
                        text
                        @click="dialogRemove.visible = false"
                        :disabled="loading"
                        >{{ $t("common.form.cancel") }}</v-btn
                    >
                    <v-btn
                        color="red darken-1"
                        text
                        @click="confirmDeletion()"
                        :loading="loading"
                        ><span>{{ $t("common.form.confirm") }}</span></v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { permission } from "@components/mixins/permission";
import { helper } from "@components/mixins/helper";
import { snackbar } from "@components/mixins/snackbar";
import BatchAddSymbolMapDialog from "./BatchAddSymbolMapDialog";

export default {
    mixins: [permission, helper, snackbar],
    components: { BatchAddSymbolMapDialog },
    props: {
        tableHeight: Number,
    },
    data() {
        return {
            apiSearch: "",
            pkSearch: "",
            selectedLpId: -1,
            selectedLp: this.$t("lp.symbolMapping.all"),
            search: "",
            dialogMapping: {
                visible: false,
                symbolMapInfo: {},
                fullscreen: false,
                title: null,
            },
            dialogRemove: {
                title: this.$t("lp.symbolMapping.removeConfirm"),
                fullscreen: false,
                visible: false,
            },
            updateTitle: {
                id: this.$t("lp.symbolMapping.id"),
                api_code: this.$t("lp.symbolMapping.lpApiName"),
                symbol: this.$t("lp.symbolMapping.symbol"),
                pk: this.$t("lp.symbolMapping.pkName"),
                ratio: this.$t("lp.symbolMapping.multiplier"),
            },
            removeData: null,
        };
    },
    computed: {
        ...mapState("LP", [
            "symbolMapData",
            "symbolMapHeader",
            "loading",
            "lpList",
            "updateStatus",
            "batchAddLPId",
        ]),
        lpSpecifiedSymbolMapData() {
            return this.selectedLpId == -1
                ? this.symbolMapData
                : this.symbolMapData.filter(
                      (item) => item.lp_id === this.selectedLpId
                  );
        },
        filteredData() {
            return this.lpSpecifiedSymbolMapData
                .filter(
                    (item) =>
                        this.activeLP.includes(item.lp_name.toUpperCase()) &&
                        item.api_code
                            .toUpperCase()
                            .match(this.apiSearch.toUpperCase()) &&
                        item.pk.toUpperCase().match(this.pkSearch.toUpperCase())
                )
                .map((item) => {
                    item.computedId = item.id + "-" + item.api_code;
                    return item;
                });
        },
        activeLP() {
            let result = [];
            this.lpList.map((item) => {
                if (item.active === 1) {
                    result.push(item.lp_name.toUpperCase());
                }
            });
            return result;
        },
    },
    watch: {
        lpList: {
            immediate: true,
            handler(nv) {
                if (nv.length) {
                    this.selectedLpId = this.batchAddLPId;
                    this.selectedLp =
                        this.batchAddLPId === -1
                            ? this.$t("lp.symbolMapping.all")
                            : nv.find((item) => item.id === this.selectedLpId)
                                  .lp_name;
                }
            },
        },
        selectedLpId: {
            immediate: true,
            handler(lp_id) {
                this.getLPSymbolMapAction();
            },
        },
        updateStatus(nv) {
            if (nv) {
                this.dialogRemove.visible = false;
                this.dialogMapping.visible = false;
                this.UPDATE_STATUS(false);
                this.getLPSymbolMapAction();
            }
        },
    },
    methods: {
        ...mapActions("LP", [
            "getLPSymbolMapAction",
            "updateLPSymbolMapAction",
            "deleteLPSymbolMapAction",
        ]),
        ...mapMutations("LP", ["UPDATE_STATUS", "UPDATE_BATCH_ADD_LP_ID"]),
        /**
         * On lp selection change
         * @param   {[type]}  data  [data description]
         * @return  {[type]}        [return description]
         */
        changeLp(data) {
            this.selectedLpId = data.id;
            this.selectedLp = data.lp_name;
        },
        /**
         * Refresh Position Rec Data
         * @return  {[type]}  [return description]
         */
        refreshMapping() {
            this.getLPSymbolMapAction();
        },
        confirmDeletion() {
            const id = this.removeData[0].id;
            this.deleteLPSymbolMapAction({ id: id });
        },
        toggleDialog(data) {
            this.dialogMapping.visible = true;
            const editingData = {
                id: data.id,
                api_code: data.api_code,
                symbol: data.symbol,
                pk: data.pk,
                ratio: data.ratio,
            };
            this.dialogMapping.title = this.$t("lp.symbolMapping.updateTitle");
            this.dialogMapping.symbolMapInfo = editingData;
        },
        updateMapping() {
            this.updateLPSymbolMapAction(this.dialogMapping.symbolMapInfo);
        },
        onSearch(field) {
            setTimeout(() => {
                this.$refs[field].focus();
            }, 200);
        },
        handleAddSymbol(id, name) {
            this.$refs.batchDialog.open(id, name);
        },
    },
};
</script>
